import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import api from "@/lib/api";

export default function GiftProgress({ childId }) {
  const [g, setG] = useState(null);
  useEffect(() => { api.get(`/children/${childId}/gift-status`).then(({ data }) => setG(data)).catch(() => {}); }, [childId]);
  if (!g) return null;
  const m = Math.min(g.eligible ? g.best_months : g.months, g.months_needed);
  return (
    <div className="mt-3 rounded-2xl bg-pink-50 border-2 border-pink-300 p-3 text-sm" data-testid={`gift-progress-${childId}`}>
      <p className="font-bold flex items-center gap-1.5"><Gift size={15} className="text-pink-500" /> Year-end gift
        {g.eligible && <span className="ml-auto text-xs font-bold text-green-700" data-testid={`gift-eligible-${childId}`}>Earned!</span>}</p>
      <div className="flex gap-0.5 mt-2" aria-hidden>
        {Array.from({ length: g.months_needed }, (_, i) => <span key={i} className={`h-2 flex-1 rounded-full ${i < m ? "bg-pink-500" : "bg-pink-200"}`} />)}
      </div>
      <p className="text-xs text-slate-600 mt-1.5" data-testid={`gift-status-${childId}`}>
        <b>{m}/{g.months_needed}</b> months in a row · <b>{g.syllabus}%</b> achievement (need {g.syllabus_needed}%). The Holiday Pack counts as 2 months; renew within 7 days to keep the streak.
      </p>
    </div>
  );
}
